import styled from "styled-components";

import theme from "../../styles/theme";

export const Container = styled.span`
  @keyframes slideinTriangle {
    0% {
      margin-right: 100%;
    }

    50% {
      margin-right: 100%;
    }

    100% {
      margin-right: 0%;
    }
  }

  @media (orientation: landscape) {
    div {
      display: flex;
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .minor {
      overflow: hidden;
      border-top: 150px solid transparent;
      border-right: 170px solid #fff;
    }

    .bigger {
      background-color: white;
      height: 150px;
      width: 160px;
    }

    p {
      position: absolute;
      font-size: 32px;
      color: ${theme.primaryDefault};
      width: 170px;
      height: 66px;
      z-index: 9;
      font-weight: 600;
      text-align: center;
      bottom: 50px;
      right: 15px;
    }
  }

  @media (orientation: portrait) {
    div {
      overflow: hidden;
      position: absolute;
      width: 0;
      height: 0;
      border-top: 150px solid transparent;
      border-left: 170px solid #fff;
      border-bottom: 150px solid transparent;
      transform: rotate(305deg);
      overflow: hidden;
      bottom: 341px;
      /* bottom: 261px; */
      right: 59px;

      @media screen and (min-width: 1024px) {
        bottom: 330px;
      }
    }

    p {
      position: absolute;
      font-size: 32px;
      color: ${theme.primaryDefault};
      width: 170px;
      height: 66px;
      z-index: 9;
      font-weight: 600;
      text-align: center;
      bottom: 449px;
      /* bottom: 369px; */
      right: 66px;
      transform: rotate(36deg);

      @media screen and (min-width: 1024px) {
        bottom: 435px;
      }
    }
  }
`;
